class i18nModal extends HTMLElement {
  async connectedCallback() {
    this.SETTINGS = {
      'US': {
        url: 'https://www.roominabox.us',
        title: 'Do you want to order within the USA?',
        continue: 'Visit US shop',
        cancel: 'No, thanks.'
      },
      'CH': {
        url: 'https://www.roominabox.ch',
        title: 'Möchtest du in die Schweiz bestellen?',
        continue: 'Zum Schweizer Shop',
        cancel: 'Nein, danke.'
      },
      'UK': {
        url: 'https://www.roominabox.uk',
        title: 'Do you want to order to the UK?',
        continue: 'Visit UK shop',
        cancel: 'No, thanks.'
      },
      'IT': {
        url: 'https://www.roominabox.it',
        title: 'Vuoi ordinare in Italia?',
        continue: 'Visita il negozio IT',
        cancel: 'No, grazie.'
      },
      'FR': {
        url: 'https://www.roominabox.fr',
        title: 'Veux-tu passer commande pour la France?',
        continue: 'Visite la boutique FR',
        cancel: 'Non, merci.'
      },
      'ES': {
        url: 'https://www.roominabox.es',
        title: '¿Quiere realizar un pedido a España?',
        continue: 'Ir a la tienda española',
        cancel: 'No, gracias.'
      },
    };
    this.DEFAULT_SETTINGS = {
      'DE': {
        url: 'https://www.roominabox.de',
        title: 'Möchtest du innerhalb der EU bestellen?',
        continue: 'Zum EU Shop',
        cancel: 'Nein, danke.'
      },
      'EU': {
        url: 'https://www.roominabox.com',
        title: 'Do you want to visit our English shop?',
        continue: 'Visit EU shop',
        cancel: 'No, thanks.'
      }
    };
    this.DAYS_IN_THE_FUTURE = 30;
    this.elTitle = this.querySelector('[data-title]');
    this.elButtonContinue = this.querySelector('[data-button-continue]');
    this.elsButtonCancel = this.querySelectorAll('[data-button-cancel]');
    this.currentShopUrl = window.Shopify?.shop_url;
    this.currentShopCountry = window.Shopify?.country?.toUpperCase();
    this.currentShopLanguage = window.Shopify?.locale?.toUpperCase();
    
    this.excludeLinks = [];
    try {
      this.excludeLinks = JSON.parse(this.querySelector('[data-exclude-configuration]').innerText);
    } catch(e) {};
    const isExcludeRoute = this.excludeLinks.links.includes(window.location.pathname);
    const LATEST_BANNER_CHECK = !!this.getCookie('i18nChecked') && parseFloat(this.getCookie('i18nChecked'));
    if (!isExcludeRoute && (!LATEST_BANNER_CHECK || this.compareTimestamp(LATEST_BANNER_CHECK))) {
      this.init();
    }
  }

  async init() {
    const currentUserLocale = await fetch('/browsing_context_suggestions.json').then((r) => r.json()).then((r) => r?.detected_values);
    const currentUserCountry = currentUserLocale?.country?.handle || 'DE';
    const currentBrowserLanguage = navigator.language.includes('-') ? navigator.language.split('-')[0].toUpperCase() : navigator.language.toUpperCase();
    console.log('currentUserCountry', currentUserCountry);
    console.log('currentUserCountry', currentBrowserLanguage);
    if (this.SETTINGS[currentUserCountry]) {
      this.currentSettings = this.SETTINGS[currentUserCountry];
    } else {
      this.currentSettings = currentBrowserLanguage === 'DE' ? this.DEFAULT_SETTINGS[currentBrowserLanguage] : this.DEFAULT_SETTINGS['EU'];
    }
    console.log('currentSettings', this.currentSettings);
    console.log('currentShopUrl', this.currentShopUrl);
    if (this.currentSettings && this.currentSettings.url !== this.currentShopUrl) {
      this.fillElements();
      this.bindEvents();
      this.showModal();
    }
  }

  compareTimestamp(timestamp) {
    return timestamp < new Date().getTime();
  }

  setTimestamp() {
    return new Date().getTime() + (this.DAYS_IN_THE_FUTURE * 24 * 60 * 60 * 1000);
  }

  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  
  getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  
  checkCookie() {
    let user = getCookie("username");
    if (user != "") {
      alert("Welcome again " + user);
    } else {
      user = prompt("Please enter your name:", "");
      if (user != "" && user != null) {
        setCookie("username", user, 365);
      }
    }
  }

  showModal() {
    this.classList.add('open');
  }

  closeModal() {
    this.rememberClosing();
    this.classList.remove('open');
  }

  rememberClosing() {
    this.setCookie('i18nChecked', this.setTimestamp(), this.DAYS_IN_THE_FUTURE);
  }

  bindEvents() {
    this.elsButtonCancel.forEach((el) => el.addEventListener('click', this.onButtonCloseClick.bind(this)));
    this.elButtonContinue.addEventListener('click', this.onButtonContinueClick.bind(this));
  }

  onButtonCloseClick(e) {
    this.closeModal();
  }

  onButtonContinueClick(e) {
    this.rememberClosing();
    window.location.href = this.currentSettings.url;
  }

  fillElements() {
    this.elTitle.innerHTML = this.currentSettings.title;
    this.elButtonContinue.innerHTML = this.currentSettings.continue;
    this.elsButtonCancel.forEach((el) => {
      if (el.innerHTML === '') {
        el.innerHTML = this.currentSettings.cancel;
      }
    });
  }
}

if("customElements" in window) {
  customElements.define("i18n-modal", i18nModal);
}